module.exports = __webpack_public_path__ + "img/guojunwang.675eddb2.png";